<div class="page-wide">
  <h1>Meeting & Events</h1>

  <div class="d-flex justify-content-between">
    <div class="brand-left w-60">
      <img src="assets/images/brand-development.webp" />
    </div>
    <div class="flex-fill">
      <form class="clr-form" [formGroup]="meetingEventsForm" (ngSubmit)="onSubmit()">
        <div class="">
          <div class="d-flex">
            <div class="flex-fill p-2">
              <label for="firstName" class="form-label">First Name</label>
              <input formControlName="firstName" type="name" id="firstName" class="form-control" />
            </div>
            <div class="flex-fill p-2">
              <label for="lastName" class="form-label">Last Name</label>
              <input formControlName="lastName" type="name" id="lastName" class="form-control" />
            </div>
          </div>


          <div class="d-flex">
            <div class="flex-fill p-2">
              <label for="email" class="form-label">Email</label>
              <input formControlName="email" type="email" id="email"
                class="form-control" />
            </div>
            <div class="flex-fill p-2">
              <label for="phone" class="form-label">Phone Number</label>
              <input formControlName="phone" type="phone" id="phone" class="form-control" />
            </div>
          </div>


          <!-- <div class="clr-col-6">
            <clr-date-container>
              <label>Arrival</label>
              <input type="date" clrDate formControlName="arrival" />
            </clr-date-container>
          </div>
          <div class="clr-col">
            <clr-date-container>
              <label>Departure</label>
              <input type="date" clrDate formControlName="departure" />
            </clr-date-container>
          </div> -->


          <div class="d-flex">
            <div class="flex-fill p-2">
              <label for="groupSize" class="form-label">Group Size</label>
              <input formControlName="groupSize" type="number" id="groupSize" class="form-control" />
            </div>
            <div class="flex-fill p-2">
              <label for="rooms" class="form-label">Number of Rooms</label>
              <input formControlName="rooms" type="number" id="rooms" class="form-control" />
            </div>
          </div>

          <div class="Hotel p-2">
            <label for="hotel" class="form-label">Hotel/Organization</label>
            <div class="clr-control-container">
              <ng-select formControlName="propertyId" [items]="properties" bindLabel="name" bindValue="id"
                groupBy="state" placeholder="Select a location" [searchFn]="propertySearchFn">
                <ng-template ng-optgroup-tmp let-item="item">
                  {{item.state || 'Others'}}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{item.name}} <br />
                  <small><strong>{{item.city}}</strong></small>
                </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="text-area-full p-2">
            <label for="additionalMsg" class="form-label">Requirements</label>
            <textarea formControlName="additionalMsg" placeholder="Type here" class="form-control"></textarea>
          </div>

          <div class="d-grid gap-2 p-2">
            <button class="btn btn-primary" [disabled]="!meetingEventsForm.valid" type="submit">Send</button>
          </div>

          <div class="alert alert-success" role="alert" *ngIf="showSuccess">
            Your message has been sent Successfully!
          </div>

        </div>
      </form>
    </div>
  </div>
</div>